import { ChildUser, FamilyChildProfile } from "@joonapp/web-shared"
import dayjs from "dayjs"

import i18n from "../locales/i18n"
import { FamilyMail } from "../types"

export const getMessageTime = (mail: FamilyMail) => {
  const messageTime = dayjs(mail.sent_datetime)
  const now = dayjs()
  const diffInMinutes = now.diff(messageTime, "minute")

  if (diffInMinutes < 2) {
    return i18n.t("MAIL_JUST_NOW")
  }

  if (diffInMinutes < 60) {
    return i18n.t("MAIL_MINUTES_AGO", { count: diffInMinutes })
  }

  if (messageTime.isSame(now, "day")) {
    return messageTime.format("h:mm A")
  }

  return messageTime.format("MMM D")
}

export const getMostRecentMessage = (
  mail: FamilyMail[],
  childUserId: number
) => {
  return mail.find(
    (mail) => mail.sender.id === childUserId || mail.receiver.id === childUserId
  )
}

export const getChildFromMail = (mail: FamilyMail, childUserId: number) => {
  return (
    mail.sender.id === childUserId ? mail.sender : mail.receiver
  ) as ChildUser
}

export const sortMailByUnreadAndDate = (
  mail: FamilyMail[],
  childUserId: number
) => {
  return [...mail].sort((a, b) => {
    // Sort unread messages from child first
    const aIsUnreadFromChild =
      a.read_datetime === null && a.sender.id === childUserId
    const bIsUnreadFromChild =
      b.read_datetime === null && b.sender.id === childUserId

    if (aIsUnreadFromChild && !bIsUnreadFromChild) return -1
    if (!aIsUnreadFromChild && bIsUnreadFromChild) return 1

    // If both are read or both are unread from child, sort by sent_datetime (newest first)
    return (
      new Date(b.sent_datetime).getTime() - new Date(a.sent_datetime).getTime()
    )
  })
}

export const sortChildrenByRecentMail = (
  children: FamilyChildProfile[],
  mail: FamilyMail[]
) => {
  return children.sort((a, b) => {
    const aMail = mail.find(
      (m) => m.sender.id === a.user.id || m.receiver.id === a.user.id
    )
    const bMail = mail.find(
      (m) => m.sender.id === b.user.id || m.receiver.id === b.user.id
    )

    if (aMail && bMail) {
      return (
        new Date(bMail.sent_datetime).getTime() -
        new Date(aMail.sent_datetime).getTime()
      )
    } else if (aMail) {
      return 1
    } else if (bMail) {
      return -1
    }

    return a.user.id - b.user.id
  })
}
